<template>
  <div>
    <b-row v-if="isRange">
      <b-col :cols="6" style="padding-right: 3px;">
        <b-form-input
          :value="value"
          @change="v => $emit('change', {value: v})"
          type="number"
          placeholder="start"
          :state="showErrors && value !== 0 && !value ? false : null"
          required />
      </b-col>
      <b-col :cols="6" style="padding-left: 3px;">
        <b-form-input
          :value="value2"
          @change="v => $emit('change', {value2: v})"
          type="number"
          placeholder="end"
          :state="showErrors && value2 !== 0 && !value2 ? false : null"
          required />
      </b-col>
    </b-row>

    <b-form-input
      v-else
      :value="value"
      @change="v => $emit('change', {value: v})"
      type="number"
      placeholder="value"
      :state="showErrors && value !== 0 && !value ? false : null"
      required />
  </div>
</template>

<script>
  export default {
    name: 'NumericInput',

    props: {
      showErrors: Boolean,
      isRange: Boolean,
      value: Number,
      value2: Number
    },
  };
</script>

<style scoped>

</style>
